/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { elementInViewport, getWindowSize, scrollTo } from '../../utils/dom.mjs';
import '../../_chunks/dep-34428f12.mjs';
import '../../_chunks/dep-b390ff23.mjs';
import '../../_chunks/dep-1c40d002.mjs';
import '../../_chunks/dep-8a0ff305.mjs';
import '../../_chunks/dep-e9ff4ce8.mjs';
import '../../_chunks/dep-c54c9f32.mjs';
import '../../_chunks/dep-61150968.mjs';
import '../../_chunks/dep-1f286011.mjs';
import '../../_chunks/dep-3ced59c9.mjs';
import '../../utils/easing.mjs';

function scrollToElm(elm) {
  var rect = elm.getBoundingClientRect();
  if (!elementInViewport(elm)) {
    var winHeight = getWindowSize().height;
    scrollTo(rect.top - (winHeight / 2 - rect.height / 2), {});
  }
}

export { scrollToElm as default };
//# sourceMappingURL=scrollToElm.mjs.map
